import React, { forwardRef } from 'react'
import Spinner from 'components/UI/Spinner'
import { Button, ButtonTextWrapper } from 'components/DetailCard'
import styled from 'styled-components'
import { mobileSize } from 'theme'
// eslint-disable-next-line react/display-name
const RedeemSKUButton = forwardRef((props, ref) => {
  const { children, onClick, disabled, isFetchingProfile } = props
  return (
    <ButtonWrapper>
      <Button onClick={onClick} disabled={disabled} ref={ref}>
        {isFetchingProfile && <Spinner customcolor="#ffffff" size={16} />}
        <ButtonTextWrapper paddingLeft={isFetchingProfile}>
          {children}
        </ButtonTextWrapper>
      </Button>
    </ButtonWrapper>
  )
})

const ButtonWrapper = styled.div`
  margin-right: 16px;
  @media ${mobileSize} {
    margin-right: 0;
    width: 100%;
  }
`
export default RedeemSKUButton
